import { render, staticRenderFns } from "./roi.vue?vue&type=template&id=7e4ad11f&scoped=true&"
import script from "./roi.vue?vue&type=script&lang=js&"
export * from "./roi.vue?vue&type=script&lang=js&"
import style0 from "./roi.vue?vue&type=style&index=0&id=7e4ad11f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4ad11f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4ad11f')) {
      api.createRecord('7e4ad11f', component.options)
    } else {
      api.reload('7e4ad11f', component.options)
    }
    module.hot.accept("./roi.vue?vue&type=template&id=7e4ad11f&scoped=true&", function () {
      api.rerender('7e4ad11f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/roi.vue"
export default component.exports